export default {
  folder: "x90-plus",
  interior: {
    points: [
      [2000, -400, 0], // 12.3-inch Dual Multimedia Screen
      [1000, -1600, -800], // Premium Leather Seats with Main Driver Seat Memory
      [2000, -1000, -120], // Electric AC Control Screen
      [2000, -1700, 200], // Mobile Wireless Charging
      [1500, 2000, 0], // Panoramic Sunroof
      [2000, -1200, 250], // Intelligent Air Conditioning Zoning System
    ],
  },
  exterior: {
    hotspots: {
      // Headlight LED
      h1: {
        popup: 1,
        point: [
          [44, 45], // f1
          [37, 45], // f2
          [31, 45], // f3
          [24, 46], // f4
          [18, 47], // f5
          [16, 46], // f6
          [14, 45], // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          [83, 40], // f23
          [84, 43], // f24
          [84, 46], // f25
          [83, 48], // f26
          [79, 50], // f27
          [75, 50], // f28
          [69, 51], // f29
          [61, 51], // f30
          [54, 50], // f31
          [46, 48], // f32
          [39, 47], // f33
          [32, 45], // f34
          [55, 46], // f35
          [48, 45], // f36
        ],
      },
      // Eye-catching R20 alloy wheels
      h2: {
        popup: 2,
        point: [
          [54, 65], // f1
          [47, 65], // f2
          [41, 65], // f3
          [35, 66], // f4
          [30, 65], // f5
          [26, 64], // f6
          [70, 63], // f7
          [67, 65], // f8
          [63, 67], // f9
          [59, 69], // f10
          [55, 71], // f11
          [51, 72], // f12
          [46, 73], // f13
          [42, 73], // f14
          null, // f15
          null, // f16
          null, // f17
          [57, 73], // f18
          [52, 74], // f19
          [48, 74], // f20
          [43, 72], // f21
          [39, 72], // f22
          [34, 69], // f23
          [76, 62], // f24
          [74, 64], // f25
          [71, 65], // f26
          [68, 67], // f27
          [63, 68], // f28
          [57, 69], // f29
          [51, 68], // f30
          [45, 67], // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          [58, 64], // f36
        ],
      },
      // Adaptive Cruise Control,
      h3: {
        popup: 3,
        point: [
          [62, 31], // f1
          [58, 32], // f2
          [54, 33], // f3
          [49, 34], // f4
          [44, 34], // f5
          [39, 35], // f6
          [35, 36], // f7
          [33, 36], // f8
          [31, 36], // f9
          [31, 35], // f10
          [30, 34], // f11
          [30, 33], // f12
          [31, 32], // f13
          [32, 31], // f14
          [34, 28], // f15
          [36, 27], // f16
          [64, 29], // f17
          [66, 30], // f18
          [68, 32], // f19
          [68, 33], // f20
          [68, 35], // f21
          [67, 36], // f22
          [66, 36], // f23
          [65, 37], // f24
          [62, 38], // f25
          [59, 38], // f26
          [55, 37], // f27
          [51, 36], // f28
          [46, 35], // f29
          [41, 34], // f30
          [37, 33], // f31
          [34, 32], // f32
          [33, 32], // f33
          [67, 31], // f34
          [65, 31], // f35
          [64, 31], // f36
        ],
      },
      // Taillight filled with 236 LED particles
      h4: {
        popup: 4,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          [84, 38], // f7
          [82, 41], // f8
          [79, 45], // f9
          [75, 48], // f10
          [69, 51], // f11
          [63, 54], // f12
          [59, 56], // f13
          [51, 57], // f14
          [62, 56], // f15
          [55, 57], // f16
          [47, 57], // f17
          [40, 56], // f18
          [34, 55], // f19
          [28, 52], // f20
          [22, 49], // f21
          [18, 46], // f22
          [15, 43], // f23
          [14, 40], // f24
          [13, 37], // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
      // 2.0 TGDI engine with 7 Dual Clutch Transmission (DCT)
      h5: {
        popup: 5,
        point: [
          [37, 38], // f1
          [32, 38], // f2
          [27, 37], // f3
          [24, 37], // f4
          [22, 38], // f5
          [22, 38], // f6
          [22, 38], // f7
          [22, 37], // f8
          [22, 37], // f9
          [24, 35], // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          [74, 34], // f21
          [74, 35], // f22
          [76, 37], // f23
          [78, 38], // f24
          [79, 38], // f25
          [80, 39], // f26
          [79, 40], // f27
          [77, 41], // f28
          [74, 42], // f29
          [70, 42], // f30
          [66, 42], // f31
          [61, 42], // f32
          [55, 42], // f33
          [49, 41], // f34
          [46, 40], // f35
          [41, 39], // f36
        ],
      },
      // One-click Electric Tailgate
      h6: {
        popup: 6,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          null, // f9
          null, // f10
          [78, 58], // f11
          [77, 56], // f12
          [73, 59], // f13
          [67, 62], // f14
          [61, 65], // f15
          [55, 67], // f16
          [48, 67], // f17
          [40, 66], // f18
          [33, 64], // f19
          [26, 61], // f20
          [23, 59], // f21
          [20, 58], // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
    },
  },
};
